<template>
	<div>
		<ux-panel>
			<ux-panel-body v-if="loading">Loading...</ux-panel-body>

			<table v-else class="ux-table is-striped layout-fixed" cellpadding="0" cellspacing="0" border="0">
				<thead>
					<tr>
						<th class="buttons-cell"></th>
						<th style="width: 100px">ID#</th>
						<th>Date</th>
						<th>Status</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="order in orderList" :key="order.id">
						<td class="buttons-cell">
							<ux-btn circle color="text-primary" aria-label="Edit Address" title="Edit address" :to="`/profile/order/${order.id}`"><i class="fas fa-receipt"/></ux-btn>
						</td>
						<td>{{ order.id }}</td>
						<td>{{ order.order_date | dateFormat('MMM Do, YYYY') }}</td>
						<td>{{ order.processing_status | capitalize }}</td>
						<td>{{ order.total | currency }}</td>
					</tr>
				</tbody>
			</table>
		</ux-panel>

		<ux-pagination v-if="!hidePagination && pageCount > 1" v-model="pagination.page" :page-count="pageCount" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import filters from 'common/filters';

export default {
	mixins: [filters],

	props: {
		hidePagination: { type: Boolean, default: false }
	},

	data()
	{
		return {
			loading: true,
			total: 0,
			pagination: {
				per_page: 10,
				page: 0,
				sort_by: 'order_date',
				sort_desc: true,
			}
		}
	},

	computed: {
		...mapGetters('profile', ['orderList']),

		pageCount()
		{
			return Math.ceil(this.total / this.pagination.per_page);
		}
	},

	watch: {
		pagination: {
			deep: true,
			handler() {
				this.refreshList();
			}
		}
	},

	methods: {
		...mapActions('profile', ['fetchOrderList']),

		async refreshList()
		{
			this.loading = true;

			try
			{
				var result = await this.fetchOrderList(this.pagination);
				this.total = result.total;
			}
			finally
			{
				this.loading = false;
			}
		},
	},

	mounted()
	{
		this.refreshList();
	}
}
</script>